module.exports = __webpack_public_path__ + "img/ca_zampa_animale_2.3f74e49b.jpg";